// extracted by mini-css-extract-plugin
export var hero = "index-module--hero--14Mhx";
export var fadeIn = "index-module--fade-in--2rQ12";
export var headerContainer = "index-module--headerContainer--3Bh9h";
export var bigButton = "index-module--bigButton--3TYMb";